// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Chatbot_wrapper__DvD5l"};